// Pricing data from MAK_Preisliste_Vorlage.xlsx - Auto-generated

import { getGatePrice } from './gatePricing';
import { getGatePostPrice } from './gatePostPricing';

// Model descriptions and images (served locally)
const modelInfo = {
  'LUNAR': { description: 'Der schlichte Alu-Lamellenzaun', image: '/images/models/lunar.png' },
  'ASTRAL': { description: 'Lattenabstände blickdicht', image: '/images/models/astral.png' },
  'SOLARIS': { description: 'Der moderne Alu-Lamellenzaun', image: '/images/models/solaris.png' },
  'ECLIPSE': { description: 'Der kreative Alu-Lamellenzaun', image: '/images/models/eclipse.png' },
  'GALACTIC': { description: 'Der schlichte Alu-Einzelstabzaun', image: '/images/models/galactic.png' },
  'ORBIT': { description: 'Der kreative Alu-Lamellenzaun', image: '/images/models/orbit.png' },
  'STELLAR': { description: 'Zaunelement ohne Einfassprofil', image: '/images/models/stellar.png' },
};

export const fenceModels = [
  {
    id: 'astral',
    name: 'ASTRAL',
    description: modelInfo['ASTRAL'].description,
    image: modelInfo['ASTRAL'].image,
    basePrice: 111.0,
    heightPricing: [
      { height: 50.0, pricePerMeter: 111.0 },
      { height: 62.5, pricePerMeter: 121.0 },
      { height: 75.0, pricePerMeter: 127.0 },
      { height: 87.5, pricePerMeter: 134.0 },
      { height: 100.0, pricePerMeter: 143.0 },
      { height: 112.5, pricePerMeter: 151.0 },
      { height: 125.0, pricePerMeter: 157.0 },
      { height: 150.0, pricePerMeter: 172.0 },
      { height: 180.0, pricePerMeter: 195.0 },
      { height: 200.0, pricePerMeter: 225.0 },
    ]
  },
  {
    id: 'eclipse',
    name: 'ECLIPSE',
    description: modelInfo['ECLIPSE'].description,
    image: modelInfo['ECLIPSE'].image,
    basePrice: 162.0,
    heightPricing: [
      { height: 75.0, pricePerMeter: 162.0 },
      { height: 87.5, pricePerMeter: 167.0 },
      { height: 100.0, pricePerMeter: 180.0 },
      { height: 112.5, pricePerMeter: 183.0 },
      { height: 125.0, pricePerMeter: 194.0 },
      { height: 150.0, pricePerMeter: 225.0 },
      { height: 175.0, pricePerMeter: 289.0 },
      { height: 200.0, pricePerMeter: 347.0 },
    ]
  },
  {
    id: 'galactic',
    name: 'GALACTIC',
    description: modelInfo['GALACTIC'].description,
    image: modelInfo['GALACTIC'].image,
    basePrice: 188.0,
    heightPricing: [
      { height: 50.0, pricePerMeter: 188.0 },
      { height: 60.0, pricePerMeter: 199.0 },
      { height: 70.0, pricePerMeter: 209.0 },
      { height: 80.0, pricePerMeter: 224.0 },
      { height: 90.0, pricePerMeter: 243.0 },
      { height: 100.0, pricePerMeter: 248.0 },
      { height: 110.0, pricePerMeter: 262.0 },
      { height: 120.0, pricePerMeter: 276.0 },
      { height: 130.0, pricePerMeter: 280.0 },
      { height: 140.0, pricePerMeter: 297.0 },
      { height: 150.0, pricePerMeter: 312.0 },
      { height: 160.0, pricePerMeter: 327.0 },
      { height: 170.0, pricePerMeter: 343.0 },
      { height: 180.0, pricePerMeter: 361.0 },
      { height: 190.0, pricePerMeter: 375.0 },
      { height: 200.0, pricePerMeter: 391.0 },
    ]
  },
  {
    id: 'orbit',
    name: 'ORBIT',
    description: modelInfo['ORBIT'].description,
    image: modelInfo['ORBIT'].image,
    basePrice: 187.0,
    heightPricing: [
      { height: 48.0, pricePerMeter: 187.0 },
      { height: 58.0, pricePerMeter: 195.0 },
      { height: 68.0, pricePerMeter: 204.0 },
      { height: 78.0, pricePerMeter: 216.0 },
      { height: 88.0, pricePerMeter: 234.0 },
      { height: 98.0, pricePerMeter: 238.0 },
      { height: 108.0, pricePerMeter: 250.0 },
      { height: 118.0, pricePerMeter: 262.0 },
      { height: 128.0, pricePerMeter: 266.0 },
      { height: 138.0, pricePerMeter: 282.0 },
      { height: 148.0, pricePerMeter: 294.0 },
      { height: 158.0, pricePerMeter: 308.0 },
      { height: 168.0, pricePerMeter: 320.0 },
      { height: 178.0, pricePerMeter: 336.0 },
      { height: 188.0, pricePerMeter: 348.0 },
      { height: 198.0, pricePerMeter: 363.0 },
    ]
  },
  {
    id: 'stellar',
    name: 'STELLAR',
    description: modelInfo['STELLAR'].description,
    image: modelInfo['STELLAR'].image,
    basePrice: 100.0,
    heightPricing: [
      { height: 50.0, pricePerMeter: 100.0 },
      { height: 62.5, pricePerMeter: 107.0 },
      { height: 75.0, pricePerMeter: 116.0 },
      { height: 87.5, pricePerMeter: 125.0 },
      { height: 100.0, pricePerMeter: 146.0 },
      { height: 112.5, pricePerMeter: 148.0 },
      { height: 125.0, pricePerMeter: 153.0 },
      { height: 150.0, pricePerMeter: 185.0 },
      { height: 175.0, pricePerMeter: 231.0 },
      { height: 200.0, pricePerMeter: 250.0 },
    ]
  },
  {
    id: 'lunar',
    name: 'LUNAR',
    description: modelInfo['LUNAR'].description,
    image: modelInfo['LUNAR'].image,
    basePrice: 114.0,
    heightPricing: [
      { height: 52.0, pricePerMeter: 114.0 },
      { height: 76.0, pricePerMeter: 125.0 },
      { height: 100.0, pricePerMeter: 153.0 },
      { height: 124.0, pricePerMeter: 180.0 },
      { height: 148.0, pricePerMeter: 206.0 },
      { height: 172.0, pricePerMeter: 232.0 },
      { height: 196.0, pricePerMeter: 259.0 },
    ]
  },
  {
    id: 'solaris',
    name: 'SOLARIS',
    description: modelInfo['SOLARIS'].description,
    image: modelInfo['SOLARIS'].image,
    basePrice: 125.0,
    heightPricing: [
      { height: 50.0, pricePerMeter: 125.0 },
      { height: 62.5, pricePerMeter: 136.0 },
      { height: 75.0, pricePerMeter: 146.0 },
      { height: 87.5, pricePerMeter: 151.0 },
      { height: 100.0, pricePerMeter: 162.0 },
      { height: 112.5, pricePerMeter: 167.0 },
      { height: 125.0, pricePerMeter: 178.0 },
      { height: 150.0, pricePerMeter: 194.0 },
      { height: 175.0, pricePerMeter: 211.0 },
      { height: 200.0, pricePerMeter: 225.0 },
    ]
  },
];

// Post pricing by size (from Pfosten sheet)
export const postPricingBySizes = {
  '8x5': [
    { height: 56.0, price: 46.0 },
    { height: 66.0, price: 51.0 },
    { height: 76.0, price: 53.0 },
    { height: 86.0, price: 58.0 },
    { height: 96.0, price: 60.0 },
    { height: 106.0, price: 62.0 },
    { height: 116.0, price: 67.0 },
    { height: 126.0, price: 69.0 },
    { height: 136.0, price: 76.0 },
    { height: 146.0, price: 77.0 },
    { height: 156.0, price: 83.0 },
    { height: 166.0, price: 84.0 },
    { height: 176.0, price: 88.0 },
    { height: 186.0, price: 90.0 },
    { height: 196.0, price: 92.0 },
    { height: 206.0, price: 99.0 },
  ],
  '7.5x7.5': [
    { height: 56.0, price: 53.0 },
    { height: 66.0, price: 58.0 },
    { height: 76.0, price: 60.0 },
    { height: 86.0, price: 67.0 },
    { height: 96.0, price: 69.0 },
    { height: 106.0, price: 72.0 },
    { height: 116.0, price: 77.0 },
    { height: 126.0, price: 84.0 },
    { height: 136.0, price: 88.0 },
    { height: 146.0, price: 90.0 },
    { height: 156.0, price: 92.0 },
    { height: 166.0, price: 99.0 },
    { height: 176.0, price: 100.0 },
    { height: 186.0, price: 104.0 },
    { height: 196.0, price: 106.0 },
    { height: 206.0, price: 107.0 },
  ],
  '10x10': [
    { height: 56.0, price: 69.0 },
    { height: 66.0, price: 76.0 },
    { height: 76.0, price: 77.0 },
    { height: 86.0, price: 83.0 },
    { height: 96.0, price: 88.0 },
    { height: 106.0, price: 92.0 },
    { height: 116.0, price: 99.0 },
    { height: 126.0, price: 104.0 },
    { height: 136.0, price: 107.0 },
    { height: 146.0, price: 114.0 },
    { height: 156.0, price: 120.0 },
    { height: 166.0, price: 123.0 },
    { height: 176.0, price: 127.0 },
    { height: 186.0, price: 136.0 },
    { height: 196.0, price: 139.0 },
    { height: 206.0, price: 144.0 },
  ],
};


// Get post sizes for selector
export const getPostSizes = () => {
  return Object.keys(postPricingBySizes).map(size => ({
    id: size,
    label: size.replace('x', ' × ') + ' cm'
  }));
};

// Export postSizes as array for backward compatibility
export const postSizes = Object.keys(postPricingBySizes).map(size => ({
  id: size,
  label: size.replace('x', ' × ') + ' cm'
}));

// Get available height range for a model
export const getAvailableHeightRange = (modelId) => {
  const model = fenceModels.find(m => m.id === modelId.toLowerCase());
  if (!model || !model.heightPricing || model.heightPricing.length === 0) {
    return { min: 50, max: 200 };
  }
  
  const heights = model.heightPricing.map(h => h.height);
  return {
    min: Math.min(...heights),
    max: Math.max(...heights)
  };
};

// Find nearest height price (ceiling approach)
const findNearestHeightPrice = (prices, targetHeight) => {
  // Sort by height ascending
  const sorted = [...prices].sort((a, b) => a.height - b.height);
  
  // Find the first height >= targetHeight (ceiling)
  for (const item of sorted) {
    if (item.height >= targetHeight) {
      return item;
    }
  }
  
  // If no ceiling found, return the largest available
  return sorted[sorted.length - 1];
};

// Get fence price per meter for a specific model and height
export const getFencePricePerMeter = (modelId, height) => {
  const model = fenceModels.find(m => m.id === modelId.toLowerCase());
  if (!model) return 0;
  
  const heightPrice = findNearestHeightPrice(model.heightPricing, height);
  return heightPrice ? heightPrice.pricePerMeter : model.basePrice;
};

// Get post price for a specific size and height
export const getPostPrice = (postSize, fenceHeight) => {
  const prices = postPricingBySizes[postSize];
  if (!prices) return 0;
  
  // Post height is typically fence height + 50cm for burial
  const postHeight = fenceHeight + 50;
  const priceData = findNearestHeightPrice(prices, postHeight);
  return priceData ? priceData.price : 0;
};

// Calculate number of posts needed
export const calculateNumberOfPosts = (lengthCm) => {
  const panelWidth = 200; // Standard panel width in cm
  const numberOfPanels = Math.ceil(lengthCm / panelWidth);
  return numberOfPanels + 1; // Posts = panels + 1
};

// Calculate number of panels
export const calculateNumberOfPanels = (lengthCm) => {
  const panelWidth = 200;
  return Math.ceil(lengthCm / panelWidth);
};

// Main price calculation function
export const calculateTotalPrice = (
  configurationType,
  modelId,
  length,
  height,
  includePosts,
  postSize,
  gates,
  panels,
  gatePostSize,
  gatePostQuantity
) => {
  let result = {
    fenceData: null,
    gatesData: null,
    subtotal: '0',
    transportCost: '0',
    grandTotal: '0',
    freeDelivery: false,
    hasFence: false,
    hasGates: false
  };
  
  // Fence calculation
  if (configurationType === 'fence-only' || configurationType === 'fence-and-gates') {
    if (includePosts && length > 0 && height > 0) {
      result.hasFence = true;
      // Standard fence with posts
      const pricePerMeter = getFencePricePerMeter(modelId, height);
      const fencePrice = Math.round((length / 100) * pricePerMeter);
      
      const numberOfPanels = calculateNumberOfPanels(length);
      const numberOfPosts = calculateNumberOfPosts(length);
      const postPrice = getPostPrice(postSize, height);
      const postsTotal = Math.round(numberOfPosts * postPrice);
      
      result.fenceData = {
        fencePrice: fencePrice.toString(),
        postsTotal: postsTotal.toString(),
        totalPrice: (fencePrice + postsTotal).toString(),
        numberOfPanels,
        numberOfPosts,
        pricePerMeter: Math.round(pricePerMeter).toString(),
        postPrice: Math.round(postPrice).toString()
      };
    } else if (!includePosts && panels && panels.length > 0) {
      // Panels only mode
      let totalPanelPrice = 0;
      const panelDetails = [];
      
      panels.forEach((panel, index) => {
        const w = parseInt(panel.width) || 0;
        const h = parseInt(panel.height) || 0;
        const qty = parseInt(panel.quantity) || 1;
        
        if (w > 0 && h > 0) {
          const pricePerMeter = getFencePricePerMeter(modelId, h);
          const panelPrice = Math.round((w / 100) * pricePerMeter);
          const subtotal = panelPrice * qty;
          totalPanelPrice += subtotal;
          
          panelDetails.push({
            index: index + 1,
            width: w,
            height: h,
            quantity: qty,
            pricePerMeter: Math.round(pricePerMeter),
            unitPrice: panelPrice,
            subtotal
          });
        }
      });
      
      if (totalPanelPrice > 0) {
        result.hasFence = true;
      }
      
      result.fenceData = {
        fencePrice: totalPanelPrice.toString(),
        postsTotal: '0',
        totalPrice: totalPanelPrice.toString(),
        numberOfPanels: panels.length,
        numberOfPosts: 0,
        panelDetails
      };
    }
  }
  
  // Gates calculation
  if (configurationType === 'gates-only' || configurationType === 'fence-and-gates') {
    let totalGatesPrice = 0;
    const gatesResult = {
      pedestrian: [],
      double: [],
      sliding: [],
      totalGatesPrice: 0,
      gatePostsPrice: 0,
      numberOfGatePosts: 0,
      gatePostUnitPrice: 0
    };
    
    // Process each gate type
    ['pedestrian', 'double', 'sliding'].forEach(gateType => {
      if (gates[gateType]?.enabled && gates[gateType]?.items?.length > 0) {
        gates[gateType].items.forEach((item, index) => {
          const w = parseInt(item.width) || 0;
          const h = parseInt(item.height) || 0;
          const qty = parseInt(item.quantity) || 1;
          
          if (w > 0 && h > 0) {
            const price = getGatePrice(modelId, gateType, w, h);
            const subtotal = price * qty;
            totalGatesPrice += subtotal;
            
            gatesResult[gateType].push({
              index: index + 1,
              width: w,
              height: h,
              quantity: qty,
              price,
              subtotal
            });
          }
        });
      }
    });
    
    gatesResult.totalGatesPrice = totalGatesPrice;
    
    if (totalGatesPrice > 0) {
      result.hasGates = true;
    }
    
    // Gate posts
    const gatePostQty = parseInt(gatePostQuantity) || 0;
    if (gatePostSize && gatePostSize !== 'none' && gatePostQty > 0) {
      // Use the max gate height for post calculation
      let maxGateHeight = 0;
      ['pedestrian', 'double', 'sliding'].forEach(gateType => {
        gatesResult[gateType].forEach(gate => {
          if (gate.height > maxGateHeight) maxGateHeight = gate.height;
        });
      });
      
      const gatePostUnitPrice = getGatePostPrice(gatePostSize, maxGateHeight || 150);
      const gatePostsPrice = gatePostUnitPrice * gatePostQty;
      
      gatesResult.gatePostsPrice = gatePostsPrice;
      gatesResult.numberOfGatePosts = gatePostQty;
      gatesResult.gatePostUnitPrice = gatePostUnitPrice;
    }
    
    result.gatesData = gatesResult;
  }
  
  // Calculate totals
  let subtotal = 0;
  if (result.fenceData) {
    subtotal += parseInt(result.fenceData.totalPrice) || 0;
  }
  if (result.gatesData) {
    subtotal += result.gatesData.totalGatesPrice + result.gatesData.gatePostsPrice;
  }
  
  // Transport cost - no automatic calculation, handled manually
  const transportCost = 0;
  
  result.subtotal = subtotal.toString();
  result.transportCost = '0';
  result.grandTotal = subtotal.toString();
  result.freeDelivery = false;
  
  return result;
};
